<template>
  <div id="pk-member2">
      <div class="title-box">
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
          <span>{{ actState }}</span>
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
      </div>
      <div v-for="item in teamList" :key="item.name" class="team2">
          <div class="team-title2">
              <span class="team-name">战队名：{{item.name}}</span>
              <span class="complete">
                  <img v-show="item.state === '已成团'" src="@/assets/active/team-pk2/member/complete.png" alt="">
              </span>
              <span class="member-count" :class="item.memberCount === 12 ? 'active' : ''">({{ item.memberCount }}/12)</span>
              <img :ref="item.id+'arrow'" class="arrow" src="@/assets/active/team-pk2/member/arrow.png" alt="" @click="toggle(item.id)">
          </div>
          <div :ref="item.id" class="member-box2 clearfix">
              <div class="captain">
                  <div class="img-box">
                      <img class="ava" :src="item.cap && item.cap.headImg ? item.cap.headImg : defaultImg" alt="">
                      <img class="cap-logo" src="@/assets/active/team-pk/member/cap.png" alt="">
                  </div>
                  <div class='info-box'>
                      <p>{{ item.cap && item.cap.nickName ? item.cap.nickName : '-'}}
                          <img v-if="item.cap.stateName === '未通过'" class="cap-fail-tag" src="@/assets/active/team-pk2/member/fail.png" alt="">
                      </p>
                      <p>{{ item.cap ? item.cap.jgzUserId : '-' }}</p>
                  </div>
              </div>
              <div class="member">
                  <div class="mem-item" v-for="member in item.members" :key="member.jgzUserId">
                      <img v-if="member.stateName === '未通过'" class="fail-tag" src="@/assets/active/team-pk2/member/fail.png" alt="">
                      <img v-if="member.jgzUserId" class="ava" :src="member.headImg ? member.headImg : defaultImg" alt="">
                      <img v-else class="ava add-btn" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                      <p class="mem-id">{{ member.jgzUserId }}</p>
                  </div>
              </div>
          </div>
      </div>
      <div class="team">
          <div class="team-title">
              <span>更多战队，等你来战！</span>
          </div>
          <div class="member-box clearfix">
              <div class="left captain">
                  <div class="img-box">
                      <img class="ava" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                      <img class="cap-logo" src="@/assets/active/team-pk/member/cap.png" alt="">
                  </div>
                  <div class='info-box'>
                      <p>点击加入</p>
                      <p>成为队长吧~</p>
                  </div>
              </div>
              <div class="left member">
                  <div>
                      <img class="ava add-btn" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                  </div>
                  <div>
                      <img class="ava add-btn" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                  </div>
                  <div>
                      <img class="ava add-btn" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                  </div>
                  <div>
                      <img class="ava add-btn" src="@/assets/active/team-pk/member/add.png" alt="" @click="codeShow = true">
                  </div>
              </div>
          </div>
      </div>
      <div class="code-tip-box">
          <img src="@/assets/active/team-pk/member/code-tip.png" alt="">
      </div>
      <div v-show="codeShow" class="dialog-wrapper" @click.prevent.stop="codeShow = false">
          <div class="code-box">
              <h2>即可报名</h2>
              <p class="tip">截图保存二维码，添加金果子客服微信，报名成为金果子队长！</p>
              <img src="@/assets/active/team-pk/member/code.png" alt="">
              <p class="wechat">微信号：JGZCOM</p>
          </div>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
  </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'TeamPkMember2',
    data() {
        return {
            actState: '战队招募中',
            // defaultImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAFiUlEQVRoQ+1aSY8bVRD+qr2Np3uWRAlMxh5AHDkMEUsEiEwOYVHEcgDBP+DOKQgRCQmkSMCBH8APQEA4BUWRBiEgAolNw3LgmBD3QEiAydjtZbwVqm73Mnbb3a/dmowQdbO7Xr33dVW92pqQInH1t0dBmZdB/DhA86GimasArYPpXZovfZXW9jStIK5dPQPS3pxKDuE10stnp5GRCAgzZ1Hf/AHA6q7N+x2gXQN6LQAcfi7SAK0A5OcALTfM8zP00v1E1FUFpQyEa+Y6CI95G/XbQPOv8QePPBEBxUOAlvc5Ges0V34icmmAITYQtsx7Afzore3UgfZNlb2iefOLQE73+XLZVSos/RK9EIgFhC3zPICnbYH9LtD8M47s5DzF2wEt664/T0b52ShhkUDYMq8AuNMW1Pp7YP9RYlN4nikCMwcdQUSXSS/dPUnqRCBsmXUAs7aA+mYKp0sgQi+5ixpklAN2t1vWWCBsmSYAR8qtAuGe1QdTIaN8R9jrCAXC1uZFgJ/cFyBGwNBFMkqnhsGMAOFG5Rj69M2+AjEMhrQHSF+WOObRKBDLdCJZGo6dyfvxQeJNr53ASQJLAhcAGeVdZ9/1gy3zcwAnIBG6eT3ZpvkFIGdMXtupAe1qMvnu1cz4jObKJ10hHhDm73OoLzmvLIlzS9ohEVqFmjcA0ZQquc6vl/JE1JHlPhDL/MnOnToW0N5WEx1HC+MkimZEQyrk77dBRvm+YSCOb6hqQ8xIBE9DO1tAt6EmYaAV11dsjbC1eRrgt2xnbN1QEEiAvqzAP4FV9QXOHAbkMgGdJqP0zgDI4Kaq/yHJVPyDzS5L+hCffxInM9D4XUGWBuhHbH7RyhAQlTQkRW24x1fVSsC8iBvmw+jja/R7QPNa/DdSOAhki/H543CqXjSzSwBlAI0fIrbMDwC8iJ2bQFdyxJjk5z8xF8RkU9FKVgcKi2Jc7xPXzRoYBlT9Yz8AkbJ5VvyEq6KRZNfufgAiSnb95H8g/xmNFA4AWad4TI2SNDSmNi1J09KK6knjSCo+IkJuaWQfoPc0UjOrIMyhLunBmO7gWNtJUSsq8cM9j3f9UlXiyDkwnkeSDFQE5uaAfHi/OrbvJN3bC4j4iLh2dQ2kfTFV422v6xH3DRWXAC0D9On4FEnj0PveywrR3TqYNMp/flBUTOPDbCeOdqap2Uf8I5jGV81XoeGsemEV4QWZgj86kKItSX0+bovi4UGHhl8hY+XtYM2eLOeK7dEpM4aVurZ51c1vwXgQSaJr8IxSw0vEHx3iOFzSapL6XGqPpOSNH/g7MlaOiZhAO+jDDOqPOJMi1Ts9jl+MO7RqMRWI5tBLGSKya/OhBl3lAkCnYl/FM4cA8YM0SMZ10t2MIn928gkZ5Wc83x9e591grS2gN6ZFI2ZTvC1qy2TPpcMp5hdGYrKSrA4aDkGWkN5vZRUgadYhNG1JUwvjoHabwM4/Q093pUNHySg7ZxxQ+FihXvkYTM+N+IuUlZLf7AUNj/jc+odwjvTyC8NHmDTouQzgLg+Mmw7sBQh3D7eZ7hVxfJmMldARXLzRm9imakszLcAySug1RVqy0Zt7Dq5fM5EtOiM4sV1WnuUng0RZv2/WbVRIPxI6cpvoI8M7c2vrS5B23P6f+2r9ryQwJD13fZH7l2jmwFqUmNiNW+5snUBfk0GQQ3butBMlX+25nZsFvoDQaI1y85fiCIkNxDO19vYGGEc94dxzTE65ugwYhbRepfXpC92gwqI994hLykBs6+JKEe35X70PCTyU7GhJ+shju/ryUU3WefMjnXy+guu1e2hlxfZuFUoEJLgB72zLJ05nVDYN4X2DCguvTyNjaiC7QLW2nwLhJRBO2v3kcLIA/hRM79HMwoVpDh9c+y9PCxMFQR39lgAAAABJRU5ErkJggg==',
            teamList: [],
            codeShow: false,
            showLoading: false,
        }
    },
    components: {
        JgzLoading,
    },
    mounted() {
        this.showLoading = true
        this.getMember()
        // debugger
        // const url =  window.location.host + this.$route.fullPath
        // this.setupWebViewJavascriptBridge(function(bridge) {
        //     bridge.callHandler('urlUpdate', {data: url});
        // }); 
    },
    computed: {
        defaultImg() { return this.$DefaultHead }
    },
    methods: {
        //  获取团队列表，转换成可遍历形式
        getMember() {
            this.$MyAxios.get('/api/trade/teams', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    this.actState = response.data[0].busStateName
                    const teamList = [...response.data[0].teams]
                    const newTeamList = []
                    teamList.forEach(team => {
                        let newTeam = {}
                        let newMember = []
                        let members = team.members
                        let memberCount = team.members.length
                        for (let i = 0; i < 12; i++) {
                            let member = members[i]
                            if(member && member.mainMember === '1') {
                                newTeam['cap'] = member
                            } else {
                                newMember.push(member ? member : i)
                            }
                        }
                        newTeam['members'] = newMember
                        newTeam['name'] = team.name
                        newTeam['state'] = team.stateName
                        newTeam['id'] = team.id
                        newTeam['memberCount'] = memberCount
                        newTeamList.push(newTeam)
                    })
                    this.teamList = newTeamList
                }
            })
        },
        toggle(id) {
            const ele = this.$refs[id][0]
            const arrow = this.$refs[id+'arrow'][0]
            if(ele.className.indexOf('active') !== -1) {
                ele.classList.remove('active')
                arrow.classList.remove('open')
            } else {
                ele.classList.add('active')
                arrow.classList.add('open')
            }
        }
    }
}
</script>

<style lang="less" scoped>
#pk-member2 {
    background: #ffffff;
    position: relative;
    padding-bottom: 178px;
}
.dialog-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .code-box {
        height: 500px;
        width: 560px;
        border-radius: 20px;
        background: #ffffff;
        z-index: 2;
        h2 {
            font-size: 32px;
            font-weight: bold;
            padding: 30px 0;
            line-height: 36px;
        }
        p {
            line-height: 42px;
            font-size: 28px;
            padding: 0 30px;
        }
        .tip {
            margin-bottom: 20px;
            text-align: left;
        }
        .wechat {
            margin: 20px 0 30px 0;
        }
        img {
            width: 180px;
            height: 180px;
        }
        button {
            border: none;
            background-color: #FFA41F;
            outline: none;
            color: #ffffff;
            height: 88px;
            width: 500px;
            border-radius: 8px;
        }
    }
}
.title-box {
    height: 105px;
    line-height: 105px;
    text-align: center;
    img, span {
        vertical-align: middle;
    }
    img {
        margin: 0 5px;
        width: 44px;
        height: 24px;
    }
    span {
        font-size: 32px;
        color: #33333A;
        font-weight: bold;
    }
}
.team2 {
    width: 690px;
    box-shadow: 0px 4px 20px 0px rgba(149,152,166,0.16); 
    margin: 0 auto;
    margin-bottom: 30px;
    text-align: left;
    height: auto;
    .team-title2 {
        height: 88px;
        line-height: 88px;
        margin-bottom: 4px;
        overflow: hidden;
        position: relative;
        span {
            display: inline-block;
            vertical-align: middle;
        }
        .team-name {
            font-size: 28px;
            font-weight: bold;
            line-height: 38px;
            vertical-align: middle;
            color: #33333A;
            width: 410px;
            padding-left: 20px;
        }
        .member-count {
            font-size: 24px;
            font-weight: bold;
            line-height: 36px;
            text-align: right;
            width: 118px;
            margin-right: 23px;
            &.active {
                color: #FFA41F;
            }
        }
        img {
            vertical-align: middle;
        }
        .complete {
            width: 84px;
            img {
                height: 66px;
                width: 84px; 
            }
        }
        .arrow {
            height: 24px;
            width: 24px;
            transition: all .4s;
            &.open {
                transform: rotate(180deg);
            }
        }
    } 
    .member-box2 {
        height: 348px;
        display: none;
        &.active {
            display: block;
        }
        .captain {
            height: 80px;
            margin-bottom: 30px;
            position: relative;
            .info-box {
                padding-left: 120px;
                padding-right: 10px;
                font-size: 24px;
                color: #33333a;
                height: 80px;
                line-height: 36px;
                font-weight: 500;
                border-right: 1px solid #EBECF0;
                p {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    line-height: 40px;
                }
            }
            .img-box {
                position: absolute;
                top: 0px;
                left: 20px;
                height: 80px;
                width: 80px;
                .ava {
                    height: 80px;
                    width: 80px;
                    border-radius: 80px;
                }
                .cap-logo {
                    position: absolute;
                    right: -14px;
                    top: -6px;
                    width: 32px;
                    height: 42px;
                }
            }
            .cap-fail-tag {
                height: 22px;
                width: 44px;
            }
        }
        .member {
            padding: 0px 5px;
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            .mem-item {
                width: 16.5%;
                margin-bottom: 20px;
                position: relative;
                .fail-tag {
                    position: absolute;
                    top: 0;
                    right: -10px;
                    height: 22px;
                    width: 44px;
                }
            }
            .ava {
                width: 60px;
                height: 60px;
                border-radius: 60px;
            }
            .mem-id {
                line-height: 33px;
                font-size: 24px;
                color: #9598A6;
            }
            &>div {
                text-align: center;
            }
        }
    }
}
.team {
    width: 690px;
    height: 200px;
    position: relative;
    border-radius: 8px;
    box-shadow: 0px 4px 20px 0px rgba(149,152,166,0.16);
    margin: 0 auto;
    margin-bottom: 50px;
    text-align: left;
    .team-title {
        font-size: 28px;
        line-height: 36px;
        color: #33333A;
        font-weight: bold;
        padding: 20px 0 0 20px;
    }
    .captain {
        position: relative;
        height: 120px;
        width: 295px;
        padding: 30px 20px;
        .info-box {
            padding-left: 100px;
            padding-right: 10px;
            font-size: 24px;
            color: #33333a;
            height: 80px;
            line-height: 36px;
            font-weight: 500;
            border-right: 1px solid #EBECF0;
            p {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                line-height: 40px;
            }
        }
        .img-box {
            position: absolute;
            top: 20px;
            left: 20px;
            height: 80px;
            width: 80px;
            .ava {
                height: 80px;
                width: 80px;
                border-radius: 80px;
            }
            .cap-logo {
                position: absolute;
                right: -14px;
                top: -6px;
                width: 32px;
                height: 42px;
            }
        }
    }
    .member {
        padding: 30px 20px;
        display: flex;
        width: 390px;
        justify-content: space-between;
        .ava {
            width: 60px;
            height: 60px;
            border-radius: 60px;
        }
        .mem-id {
            line-height: 36px;
            font-size: 24px;
            color: #9598A6;
        }
        &>div {
            text-align: center;
        }
    }
    .finish-logo {
        position: absolute;
        height: 66px;
        width: 84px;
        top: 10px;
        right: 10px;
    }
}
.code-tip-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 178px;
    // padding: 30px 30px 54px 30px;
    background: #ffffff;
    img {
        height: 178px;
        width: 750px;
    }
}
</style>